'use client'

import React from 'react'
import { Autoplay, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import PropTypes from 'prop-types'
import ReviewsList from "@/assets/data/reviews.json"

// const videos = [
//     'https://ik.imagekit.io/perisync/hyqoo/videos/hyqoo_main_banner.mp4',
//     'https://ik.imagekit.io/perisync/hyqoo/videos/hyqoo_teams.mp4'
// ]

const Reviews = () => {

    const [hydrated, setHydrated] = React.useState(false);
    React.useEffect(() => {
        setHydrated(true);
    }, []);

    if (!hydrated) {
        // Returns null on first render, so the client and server match
        return null;
    }

    return (
        ReviewsList?.length ?
            <section className='relative max-w-7xl px-6 sm:px-3 z-10 mx-auto '>
                <div className="pl-10 md:pl-0 text-black md:mb-4 font-bold leading-10 text-center md:text-center text-[35px] mb-6" >
                    Why Talent Love Hyqoo
                </div>

                <div className="relative mx-10 sm:mx-0">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        lazy
                        speed={1000}
                        autoplay={{
                            delay: 5000, // 5 seconds
                            disableOnInteraction: false, // Continue autoplay even after interaction
                        }}
                        slidesPerView={1}
                        breakpoints={{
                            1280: {
                                slidesPerView: 3
                            },
                            764: {
                                slidesPerView: 2
                            },
                        }}
                        navigation={{
                            nextEl: '.next',
                            prevEl: '.prev',
                        }}
                        loop
                    >
                        {(ReviewsList || [])?.map((review, index) => (
                            <SwiperSlide key={index} className='pb-10 sm:pb-8'>
                                <div className='mx-auto h-full'>
                                    <Card
                                        stars={5}
                                        // quote="Hyqoo simplifies personnel relocation, making the contractual process faster and hassle-free. They ease concerns and make relocating a breeze. Impressive!"
                                        // userName="Carlos Gómez Carbajal"
                                        // position="Firewall Filtering & Security Specialist, Mexico"
                                        // userImage=""
                                        {...review}
                                    />

                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* <div className="sm:hidden mt-4 ml-4 block">
                        <button aria-label='prev' className="prev absolute left-[-50px] top-[40%]">
                            <div role='button' className="outline-none cursor-pointer prev rounded-full border p-4 lg:p-5 hover:bg-gray-200 group transition-all duration-200 bg-white" aria-label="Previous slide">
                                <svg className="group-hover:scale-125 transition-all duration-200" width="14" height="14" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17 7.99996C17 8.26517 16.8946 8.51953 16.7071 8.70706C16.5196 8.8946 16.2652 8.99996 16 8.99996L4.414 8.99996L8.708 13.292C8.89577 13.4797 9.00126 13.7344 9.00126 14C9.00126 14.2655 8.89577 14.5202 8.708 14.708C8.52023 14.8957 8.26555 15.0012 8 15.0012C7.73445 15.0012 7.47977 14.8957 7.292 14.708L1.292 8.70796C1.19887 8.61507 1.12499 8.50471 1.07458 8.38322C1.02416 8.26173 0.998213 8.13149 0.998213 7.99996C0.998213 7.86842 1.02416 7.73818 1.07458 7.61669C1.12499 7.4952 1.19887 7.38485 1.292 7.29196L7.292 1.29196C7.47977 1.10418 7.73445 0.998696 8 0.998696C8.26555 0.998696 8.52023 1.10418 8.708 1.29196C8.89578 1.47973 9.00126 1.73441 9.00126 1.99996C9.00126 2.26551 8.89577 2.52018 8.708 2.70796L4.414 6.99996L16 6.99996C16.2652 6.99996 16.5196 7.10531 16.7071 7.29285C16.8946 7.48039 17 7.73474 17 7.99996Z" fill="#EB532E"></path>
                                </svg>
                            </div>
                        </button>
                        <button aria-label='next' className="next absolute right-[-50px] top-[40%]">
                            <div role='button' className="outline-none cursor-pointer next rounded-full border p-4 lg:p-5 hover:bg-gray-200 group transition-all duration-200 bg-white" aria-label="Next slide">
                                <svg className="group-hover:scale-125 transition-all duration-200" width="14" height="14" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M-6.1207e-07 7.99996C-5.88884e-07 8.26517 0.105356 8.51953 0.292893 8.70706C0.480429 8.8946 0.734783 8.99996 0.999999 8.99996L12.586 8.99996L8.292 13.292C8.10423 13.4797 7.99874 13.7344 7.99874 14C7.99874 14.2655 8.10423 14.5202 8.292 14.708C8.47977 14.8957 8.73445 15.0012 9 15.0012C9.26555 15.0012 9.52023 14.8957 9.708 14.708L15.708 8.70796C15.8011 8.61507 15.875 8.50471 15.9254 8.38322C15.9758 8.26173 16.0018 8.13149 16.0018 7.99996C16.0018 7.86842 15.9758 7.73818 15.9254 7.61669C15.875 7.4952 15.8011 7.38485 15.708 7.29196L9.708 1.29196C9.52023 1.10418 9.26555 0.998696 9 0.998696C8.73445 0.998696 8.47977 1.10418 8.292 1.29196C8.10422 1.47973 7.99874 1.73441 7.99874 1.99996C7.99874 2.26551 8.10423 2.52018 8.292 2.70796L12.586 6.99996L0.999999 6.99996C0.734783 6.99996 0.480429 7.10531 0.292893 7.29285C0.105356 7.48039 -6.35256e-07 7.73474 -6.1207e-07 7.99996Z" fill="#EB532E"></path>
                                </svg>
                            </div>
                        </button>
                    </div> */}
                </div>
            </section> : null
    )
}

const Card = (props) => {
    const {
        stars = 5,
        quote,
        userName,
        position,
        location,
        userImage
    } = props;

    return (
        <div className="w-[90%] h-[460px] sm:h-[350px] sm:w-full mx-auto px-[6%] py-[10%] rounded-xl border shadow p-6 group hover:shadow-xl">
            <div className="w-full flex gap-1 md:mb-4 mb-8">
                {[...Array(stars)].map((_, index) => (
                    <img
                        key={index}
                        className="w-5 h-5"
                        src="/images/star.webp"
                        alt="Star"
                    />
                ))}
            </div>

            <div className="relative w-full text-black font-semibold text-base h-[170px] sm:h-auto leading-8 md:mb-6 mb-10">
                {quote}
            </div>

            <div className="relative w-full flex gap-3 mt-16 sm:mt-3 items-center justify-center client-wrap">
                <img
                    className="w-24 h-24 flex-none rounded-full object-cover"
                    src={userImage}
                    alt={`${userName}'s profile`}
                />
                <div className="w-full flex flex-col h-full">
                    <div className="w-full font-semibold">
                        {userName}
                    </div>
                    <div className="w-full text-secondary">
                        {`${position}, ${location}`}
                    </div>
                </div>
            </div>
        </div>
    );
};

// Adding prop types for validation
Card.propTypes = {
    stars: PropTypes.number,
    quote: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    position: PropTypes.string,
    userImage: PropTypes.string.isRequired
};

export default Reviews